/**
 * ////////////////////////////////////////////////
 * /////////// TRANSITIONAL TABLE SIZES ///////////
 * ////////////////////////////////////////////////
 */
export const TABLE_CELL_HEIGHT = '72px';
export const TABLE_COMPACT_HEADER_HEIGHT = '56px';
export const TABLE_COMPACT_CELL_HEIGHT = '56px';
export const TABLE_HEADER_HEIGHT = '44px';
export const TABLE_CELL_VERTICAL_ALIGNMENT = 'middle';

/**
 * ////////////////////////////////////////////////
 * ///////// TRANSITIONAL DROPDOWN SIZES //////////
 * ////////////////////////////////////////////////
 */
export const DROPDOWN_MENU_HEIGHT = '220px';
export const DROPDOWN_ITEM_DEFAULT_HEIGHT = '40px';
export const MAX_HEIGHT = parseInt(DROPDOWN_MENU_HEIGHT, 10);
export const OPTION_HEIGHT = 40;
export const OPTION_GROUP_HEIGHT = 40;
export const OPTION_WITH_HELP_HEIGHT = 64;
export const OPTION_LOADING_HEIGHT = 60;

/**
 * ////////////////////////////////////////////////
 * ///////// TRANSITIONAL TABS SIZES //////////
 * ////////////////////////////////////////////////
 */
export const TAB_INDICATOR_HEIGHT = '5px';